import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import Footer from "../../Components/Footer/footer";
import { FcEngineering } from "react-icons/fc";
import { CiCalculator1 } from "react-icons/ci";
import { useNavigate } from "react-router";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
// import { QuotationInfo } from "../../SchemaInfo/info";
// import { QuotationSchema } from "../../Schemas/quotation/quotation_schema";
import CustomSelect from "../../CustomComponent/custom_select";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";
import SimpleButton from "../../Components/layouts/simple_button";
import {
  materialPlaningInfo,
  materialNewPlanning,
} from "../../SchemaInfo/info";
import { materialPlaningListSchemaNew } from "../../Schemas/Material Planning/material_planning_new";
import CustomInput from "../../CustomComponent/custom_input";
import LoadingPage from "../../Components/layouts/loading";
import StepRoutes from "../../Routes/steps_routes";

const HydroponicMaterialPlanningNew = () => {
  const [length, setLength] = useState();
  const [width, setWidth] = useState();
  const [hydrponicType, setHydrponicType] = useState("flatbed");
  const [errors, setErrors] = useState({});
  const [projects, setProjects] = useState([]);
  const [clinetProject, setClientProject] = useState();
  const [planters, setPlanters] = useState();
  const [dutchbucket, setDutchBucket] = useState();
  const [sikit, setSiKit] = useState();
  const [officeitem, setOfficeItem] = useState();
  const [toolsMasonary, setToolsMasonary] = useState();
  const [loading, setLoading] = useState(false);
  const [checkedItems, setCheckedItems] = useState({});

  const navigate = useNavigate();

  // const validateForm = () => {
  //   const newErrors = {};
  //   if (!length || isNaN(length) || length <= 0) {
  //     newErrors.length = "Please enter a valid positive number for length.";
  //   }
  //   if (!width || isNaN(width) || width <= 0) {
  //     newErrors.width = "Please enter a valid positive number for width.";
  //   }
  //   if (!hydrponicType || hydrponicType === "Select") {
  //     newErrors.hydrponicType = "Please select a hydroponic type.";
  //   }
  //   if (!clinetProject || clinetProject === "Select") {
  //     newErrors.clinetProject = "Please select a client Project.";
  //   }
  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

  useEffect(() => {
    performRequest("GET", "/siteInspection/getAllProjects")
      .then((res) => setProjects(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  useEffect(() => {
    performRequest("GET", `/materialPlanning/getAllPlanters`)
      .then((res) => {
        if (res.status === 200) {
          setPlanters(res.data.PlanterList);
        } else {
          Toast("error", "Error while getting Details!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    performRequest("GET", `/materialPlanning/getAllDutchBucket`)
      .then((res) => {
        if (res.status === 200) {
          setDutchBucket(res.data.DutchBucketList);
        } else {
          Toast("error", "Error while getting Details!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    performRequest("GET", `/materialPlanning/getAllSiKit/`)
      .then((res) => {
        if (res.status === 200) {
          setSiKit(res.data.SiKitList);
        } else {
          Toast("error", "Error while getting Details!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    performRequest("GET", `/materialPlanning/getAllOfficeItems/`)
      .then((res) => {
        if (res.status === 200) {
          setOfficeItem(res.data.OfficeItems);
        } else {
          Toast("error", "Error while getting Details!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    performRequest("GET", `/materialPlanning/getAllToolsMasonaries/`)
      .then((res) => {
        if (res.status === 200) {
          setToolsMasonary(res.data.ToolsMasonaries);
        } else {
          Toast("error", "Error while getting Details!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  const handleDownload = (hydroponicType) => {
    const listToFilter =
      hydroponicType === "planters"
        ? planters
        : hydroponicType === "dutch_bucket"
        ? dutchbucket
        : hydroponicType === "sikit"
        ? sikit
        : hydroponicType === "officeItems"
        ? officeitem
        : hydroponicType === "tools"
        ? toolsMasonary
        : [];
    const printableContent = listToFilter
      .filter((item) => item?.count)
      .map((item, index) => {
        const specsArray = Array.isArray(item.specificationsNew)
          ? item.specificationsNew
          : JSON.parse(item.specificationsNew || "[]");
        const specsHTML = specsArray
          .map((type) =>
            type.specification && hydroponicType === type?.type
              ? `<span style="display: block; margin-top: 0;">${type.specification}</span>`
              : ""
          )
          .join("");

        return `<tr>
            <td style="text-align: center;">${index + 1}</td>
            <td style="text-align: center;">
              <img src="${
                item.image
              }" alt="Image" width="40px" style="display: block; margin: 0 auto;" />
            </td>
            <td>
              <b>${item.item}</b>
              ${
                item.hsn
                  ? `<br /><b style="color: gray;">HSN: ${item.hsn}</b>`
                  : ""
              }
              <br />
              ${specsHTML}
            </td>
            <td style="text-align: center;">${item.count} ${
          item.unit || ""
        }</td>
          </tr>`;
      });

    const newWindow = window.open("", "_blank");
    newWindow.document.write(`
      <html>
        <head>
          <style>
            body {
              font-family: Arial, sans-serif;
              margin: 20px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
            }
            th, td {
              border: 1px solid black;
              padding: 8px;
            }
            th {
              background-color: #f2f2f2;
            }
          </style>
        </head>
        <body>
          <h1 style="text-align: center;">
           Material List: ${
             hydroponicType === "planters"
               ? "100 Planters"
               : hydroponicType === "dutch_bucket"
               ? "Dutch Bucket"
               : hydroponicType === "sikit"
               ? "Si Kit"
               : hydroponicType === "officeItems"
               ? "Office Items"
               : "Tools And Machinery"
           }
          </h1>
          <table>
            <thead>
              <tr>
                <th>Sr</th>
                <th>Image</th>
                <th>Item Name</th>
                <th>Quantity</th>
              </tr>
            </thead>
            <tbody>
              ${printableContent.join("")}
            </tbody>
          </table>
        </body>
      </html>
    `);

    newWindow.document.close();
    newWindow.onafterprint = () => newWindow.close();
    newWindow.print();
  };

  if (loading) {
    return <LoadingPage />;
  }

  const handleSubmit = (values, actions) => {
    if (values) {
      setLoading(true);
      performRequest("POST", "/materialPlanning/create-hm-list", values)
        .then((res) => {
          if (res.status === 200) {
            Toast("success", "Material List created successfully!");
            navigate(`/get-material-lists`);
          } else {
            Toast("error", "Error while uploading");
          }
        })
        .catch((err) => {
          // Toast("error", "Server Error");
          // console.error("Error", err);
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row align-items-center">
                <div className="col-md-8">
                  <h2 className="page-title mb-1">
                    <FcEngineering className="fs-2  me-1" />
                    Create Material List
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
              </div>
            </div>
          </div>

          <div className="page-body">
            <div className="container-xl">
              <div className="row">
                <div className="col-12 d-md-flex">
                  <div className="col-md-3 col-sm-12 py-2 me-3">
                    <div className="card p-2 mb-3">
                      <h3 className="m-0 p-0">Notes:</h3>
                      <hr className="my-1" />
                      <ul className="mb-3">
                        <li>
                          Add length and width, including the hockey area.
                        </li>
                        <li>Length is a multiple of 4 m.</li>
                        <li>Width is a multiple of 8 m.</li>
                        <li>
                          Manually calculate the percentage of utilized area and
                          add it.
                        </li>
                      </ul>
                    </div>
                    <div className="d-flex flex-column">
                      <div className="d-flex justify-content-between">
                        <button
                          className="btn flex-grow-1 m-1"
                          onClick={() => handleDownload("planters")}
                        >
                          100 PLANTERS
                        </button>
                        <button
                          className="btn flex-grow-1 m-1"
                          onClick={() => handleDownload("dutch_bucket")}
                        >
                          DUTCH BUCKET
                        </button>
                      </div>
                      <div className="d-flex justify-content-between">
                        <button
                          className="btn flex-grow-1 m-1"
                          onClick={() => handleDownload("sikit")}
                        >
                          SI KIT
                        </button>
                        <button
                          className="btn flex-grow-1 m-1"
                          onClick={() => handleDownload("officeItems")}
                        >
                          OFFICE ITEMS
                        </button>
                      </div>
                      <div className="d-flex justify-content-between">
                        <button
                          className="btn flex-grow-1 m-1"
                          onClick={() => handleDownload("tools")}
                        >
                          TOOLS AND MACHINERY
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-9 col-sm-12 py-2">
                    <div className="card">
                      <Formik
                        initialValues={materialNewPlanning}
                        validationSchema={materialPlaningListSchemaNew}
                        onSubmit={handleSubmit}
                      >
                        {(props) => (
                          <Form>
                            <div className="card-body">
                              <div className="mb-3 row">
                                <label className="w-25 form-label required">
                                  Client Project
                                </label>
                                <div className="w-100 col">
                                  <CustomSelect type="text" name="project">
                                    <option value="">Select project</option>
                                    {projects &&
                                      projects?.map((pro) => {
                                        return (
                                          <option
                                            key={pro.id}
                                            value={pro.clientName}
                                          >
                                            {pro.clientName}
                                          </option>
                                        );
                                      })}
                                  </CustomSelect>
                                  {props.touched.project &&
                                    props.errors.project && (
                                      <p className="text-danger">
                                        {props.errors.project}
                                      </p>
                                    )}
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Polyhouse Length (4mtr)
                                </label>
                                <div className="w-100 col">
                                  <CustomSelect type="number" name="length">
                                    <option value="">Select</option>
                                    {[
                                      8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48,
                                      52, 56, 60, 64, 68, 72, 76, 80, 84, 88,
                                      92, 96, 100, 104, 108, 112, 116, 120, 124,
                                      128, 132, 136, 140, 144,
                                    ].map((number) => (
                                      <option key={number} value={number}>
                                        {number} Mtr
                                      </option>
                                    ))}
                                  </CustomSelect>
                                  {props.touched.length &&
                                    props.errors.length && (
                                      <p className="text-danger">
                                        {props.errors.length}
                                      </p>
                                    )}
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Polyhouse Width (8mtr)
                                </label>
                                <div className="w-100 col">
                                  <CustomSelect type="number" name="width">
                                    <option value="">Select</option>
                                    {[
                                      12, 20, 28, 36, 44, 52, 60, 68, 76, 84,
                                      92, 100, 108, 116, 124, 132, 140, 148,
                                      156, 164, 172, 180, 188, 196, 204, 212,
                                      220, 228, 236, 244, 252, 260, 268, 276,
                                    ].map((number) => (
                                      <option key={number} value={number}>
                                        {number} Mtr
                                      </option>
                                    ))}
                                  </CustomSelect>
                                  {props.touched.width &&
                                    props.errors.width && (
                                      <p className="text-danger">
                                        {props.errors.width}
                                      </p>
                                    )}
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="w-25 form-label required">
                                  Hydroponic type
                                </label>
                                <div className="w-100 col">
                                  <CustomSelect
                                    type="text"
                                    name="hydroponicType"
                                  >
                                    <option value="">Select</option>
                                    <option value="flatbed">flatbed</option>
                                    <option value="growbags">growbags</option>
                                    <option value="foggers">foggers</option>
                                    <option value="cea-nvph">cea-nvph</option>
                                    {/* <option value="hydroponicsOnly">
                                      Hydroponics Only
                                    </option> */}
                                  </CustomSelect>
                                  {props.touched.hydroponicType &&
                                    props.errors.hydroponicType && (
                                      <p className="text-danger">
                                        {props.errors.hydroponicType}
                                      </p>
                                    )}
                                </div>
                              </div>
                              {/* {props.values.hydroponicType ===
                              "hydroponicsOnly" ? (
                                <div className="mb-3 row">
                                  <label className="w-25 form-label col-3">
                                    Flat-NFT percent
                                  </label>
                                  <div className="w-100 col">
                                    <CustomSelect
                                      type="number"
                                      name="flatBedPercent"
                                    >
                                      <option value="">Select</option>
                                      <option value={0}>0%</option>
                                      <option value={25}>25%</option>
                                      <option value={50}>50%</option>
                                      <option value={75}>75%</option>
                                      <option value={100}>100%</option>
                                    </CustomSelect>
                                    {props.touched.flatBedPercent &&
                                      props.errors.flatBedPercent && (
                                        <p className="text-danger">
                                          {props.errors.flatBedPercent}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}
                              {props.values.hydroponicType ===
                              "hydroponicsOnly" ? (
                                <div className="mb-3 row">
                                  <label className="w-25 form-label col-3">
                                    Grow Bag percent
                                  </label>
                                  <div className="w-100 col">
                                    <CustomSelect
                                      type="number"
                                      name="growBagPercent"
                                    >
                                      <option value="">Select</option>
                                      <option value={0}>0%</option>
                                      <option value={25}>25%</option>
                                      <option value={50}>50%</option>
                                      <option value={75}>75%</option>
                                      <option value={100}>100%</option>
                                    </CustomSelect>
                                    {props.touched.growBagPercent &&
                                      props.errors.growBagPercent && (
                                        <p className="text-danger">
                                          {props.errors.growBagPercent}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              ) : (
                                ""
                              )} */}
                              <div className="mb-3 row">
                                <label className="w-25 form-label col-3">
                                  Vehicle Type
                                </label>
                                <div className="w-100 col">
                                  <CustomInput name="vehicalNum" type="text" />
                                  {props.touched.vehicalNum &&
                                    props.errors.vehicalNum && (
                                      <p className="text-danger">
                                        {props.errors.vehicalNum}
                                      </p>
                                    )}
                                </div>
                              </div>
                            </div>

                            <div className="card-footer">
                              <div className="btn-list justify-content-end">
                                <FormSubmitButton buttonText="submit" />

                                <SimpleButton
                                  buttonText="Cancel"
                                  type="secondary"
                                />
                              </div>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default HydroponicMaterialPlanningNew;
